import Transform from '@wetransfer/transfer/transformers';

export function getAccount() {
  const sideloaded = window['__session__'] || {};
  const auth = Transform.auth(sideloaded.user);

  if (!auth) {
    return {
      id: null,
      active_subscription: false,
      subscription: {},
      memberships: [],
      subdomain_name: null,
      wallpapers: [],
      email_background: null,
      payment: {},
    };
  }

  return {
    id: auth.account.id,
    active_subscription: auth.account.active_subscription || false,
    subscription: auth.subscription || {},
    memberships: auth.account.memberships || [],
    subdomain_name: auth.account.subdomain_name,
    wallpapers: [],
    email_background: null,
    payment: {},
    default_recipient_email: auth.user.default_recipient_email,
    checkout: auth.account?.checkout,
  };
}

export default getAccount();
